import { Neo } from "@singularsystems/neo-react";
import { Catalogue } from "@singularsystems/neo-react-services";
import React from 'react';
import Note from "../../Models/Notes/Note";
import INoteListHost from "../../Models/Notes/INoteListHost";
import NoteVM from "../../Models/Notes/NoteVM";
import NoteTypeCatalogueEntry from "../Catalogue/GenericComponents/NoteTypeCatalogueEntry";

interface INotesProps {
    viewModel: NoteVM;
    parentModel: INoteListHost;
}

export default class AddNotesModal extends React.Component<INotesProps> {

    public render() {
        const parentModel = this.props.parentModel;
        const viewModel = this.props.viewModel;

        return (
            <div>
                <Neo.Modal
                    title="Notes"
                    size="lg"
                    bindModel={viewModel.meta.newNote}
                    acceptButton={{ onClick: () => parentModel.isNew ? viewModel.pushNote(parentModel) : viewModel.saveNotes(parentModel) }}>
                    {(item: Note) => (
                        <div>
                            <Catalogue.FormGroupInline bind={item.meta.noteTypeId} catalogueType={NoteTypeCatalogueEntry} />
                            <Neo.FormGroupInline bind={item.meta.noteDescription} input={{ rows: 3 }} />
                            <Neo.FormGroupInline bind={item.meta.reminderDate} footerText="Select a reminder date if you would like to be reminded about this note in future." />
                        </div>
                    )}
                </Neo.Modal>
            </div>
        )
    }
}